<template>
    <div class="main">
        <splitpanes v-if="$route.name == 'Human'" :class="{ 'default-theme': !mobile }">
            <pane v-if="showSideMenu" :size="menuSize.default" :min-size="menuSize.min" :max-size="menuSize.max">
                <SideMenu :mobile="mobile" @toggleMenu="toggleMenu()" />
            </pane>

            <pane v-if="!mobile || !showSideMenu" :size="contentSize.default" :min-size="contentSize.min" :max-size="contentSize.max">
                <div class="main-content">
                <div v-if="mobile" class="burger cursor-pointer h-4" @click.prevent="toggleMenu()">
                    <svg data-v-4e59dcd0="" width="25" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
                    <rect data-v-4e59dcd0="" width="25" height="3" rx="2" fill="#37F"></rect>
                    <rect data-v-4e59dcd0="" y="8" width="25" height="3" rx="2" fill="#37F"></rect>
                    <rect data-v-4e59dcd0="" y="16" width="25" height="3" rx="2" fill="#37F"></rect>
                    </svg>
                </div>
                <router-view />
                </div>
            </pane>
        </splitpanes>

        <template v-else>
            <SideMenu />
            <div class="main-content" :class="{human: $route.name == 'Human'}">
                <router-view />
            </div>
        </template>
    </div>
</template>

<script>
  import SideMenu from "../SideMenu/SideMenu.vue"
  import { Splitpanes, Pane } from 'splitpanes'
  import 'splitpanes/dist/splitpanes.css'

  export default {
    name: 'LK',

    components: {
      SideMenu,
      Splitpanes,
      Pane
    },
    data() {
      return {
        mobile: false,
        showSideMenu: true,
        menuSize: {
          default: 30,
          min: 30,
          max: 70
        },
        contentSize: {
          default: 70,
          min: 30,
          max: 70
        }
      };
    },
    methods: {
      toggleMenu() {
        if (this.menuSize.default === 0) {
          this.openMenu();
        } else {
          this.closeMenu();
        }
      },
      openMenu() {
        this.showSideMenu = true;
        this.menuSize.default = 100;
        this.menuSize.min = 100;
        this.menuSize.max = 100;
        this.contentSize.default = 0;
        this.contentSize.min = 0;
        this.contentSize.max = 0;
      },
      closeMenu() {
        this.showSideMenu = false;
        this.menuSize.default = 0;
        this.menuSize.min = 0;
        this.menuSize.max = 0;
        this.contentSize.default = 100;
        this.contentSize.min = 100;
        this.contentSize.max = 100;
      }
    },
    created() {
      this.mobile = window.document.documentElement.clientWidth <= 960;
      
      if (this.mobile) {
        this.openMenu();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "~@/scss/vars.scss";
.main {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
}

.main-content {
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    padding: 0;
    min-height: 100vh;
    overflow: auto;

    &.human {
      margin: 0 0 0 382px;
    }
}

@media screen and (max-width: 960px) {
  .main-content {
    margin-bottom: 80px;

    .burger {
      margin: 15px;
    }
  }
}

</style>
